import { Trans } from '@lingui/macro'
import { initUser as initUserRedux } from 'actions/settings'
import axios from 'axios'
import { formatError } from 'helpers'
import React, { useContext, useEffect, useReducer, useRef } from 'react'
import { connect } from 'react-redux'
import { Notifications } from 'webbook-airways'

const GlobalContext = React.createContext()

const initialState = {
  user: {
    testmode: undefined,
    user_id: undefined,
    username: undefined,
    firstname: undefined,
    middlename: undefined,
    lastname: undefined,
    phone_country_code: undefined,
    email: undefined,
    organization: undefined,
    label: undefined,
    clients: undefined,
    roles: []
  }
}
function reducer(state, action) {
  switch (action.type) {
    case 'set_user': {
      const user = action.payload
      return { ...state, user }
    }
    case 'reset_user': {
      return {
        ...state,
        user: {
          user_id: undefined,
          username: undefined,
          firstname: undefined,
          middlename: undefined,
          lastname: undefined,
          phone_country_code: undefined,
          email: undefined,
          organization: undefined,
          label: undefined,
          clients: undefined,
          roles: []
        }
      }
    }
    case 'set_locale': {
      const locale = action.payload
      return { ...state, locale }
    }
    default: {
      return state
    }
  }
}

const GlobalProvider = connect(
  null,
  { initUserRedux }
)(function({ children, initUserRedux: initUser }) {
  const { identity } = window
  const [global, dispatch] = useReducer(reducer, initialState)
  const notifications = useRef(null)
  const { user } = global || {}
  const { user_id } = user || {}

  useEffect(() => {
    if (identity) {
      initUser(identity)
      dispatch({
        type: 'set_user',
        payload: {
          ...identity,
          roles: identity.roles.map(role => role.toLowerCase())
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    refreshToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id])

  function refreshToken() {
    if (sessionStorage.getItem('refreshed') === 'true') {
      createSuccess(<Trans>Your session has been refreshed</Trans>)
      setTimeout(() => sessionStorage.removeItem('refreshed'), 1000)
    }
  }

  function createError(error, defaultErrorMessage, type) {
    if (!axios.isCancel(error)) {
      console.error('Error:', error)
      let message = ''
      if (error.graphQLErrors) {
        message = formatError(error.graphQLErrors[0].message, type)
      } else {
        message =
          typeof error === 'string'
            ? error
            : formatError(error, defaultErrorMessage, type)
      }
      notifications.current(message, 'error')
    } else {
      // handle aborted fetch calls
    }
  }

  function createSuccess(message, type) {
    function getWord() {
      if (type === 'create') {
        return <Trans>created</Trans>
      } else if (type === 'update') {
        return <Trans>updated</Trans>
      } else if (type === 'delete') {
        return <Trans>removed</Trans>
      }
    }
    if (type) {
      notifications.current(
        <span>
          <strong>{message}</strong> <Trans>has been</Trans> {getWord()}
        </span>,
        'success'
      )
    } else {
      notifications.current(message, 'success')
    }
  }

  function setLocale(locale) {
    dispatch({ type: 'set_locale', payload: locale })
  }

  return (
    <React.Fragment>
      <div style={{ position: 'fixed', zIndex: 999999999999999 }}>
        <Notifications children={add => (notifications.current = add)} />
      </div>
      <GlobalContext.Provider
        value={{ global, setLocale, dispatch, createError, createSuccess }}
      >
        {children}
      </GlobalContext.Provider>
    </React.Fragment>
  )
})

function useGlobals() {
  const context = useContext(GlobalContext)
  return context
}

export { GlobalProvider, useGlobals }
